<template>
  <div>
    <a-card :bordered="false">
      <a-row>
        <a-col :sm="12" :xs="24">
          <head-info title="开始时间" :content="startTime" :bordered="true" />
        </a-col>
        <a-col :sm="12" :xs="24">
          <head-info title="结束时间" :content="endTime" :bordered="false" />
        </a-col>
      </a-row>
    </a-card>

    <a-card :bordered="false">
      <a-form
        :form="form"
      >
        <a-form-item
          label="姓名"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 12 }"
        >
          <a-input
            v-decorator="[
              'name',
              {rules: [{required: true,message: '请输入姓名！'},{max: 10,message: '最大不能超过10！'},{validator: this.isName}]}
            ]"
            placeholder="姓名"
          />
        </a-form-item>
        <a-form-item
          label="性别"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 12 }"
        >
          <a-select
            v-decorator="[
              'gender',
              {rules: [{ required: true, message: '请选择性别！' }]}
            ]"
            placeholder="性别"
            :options="genderList"
          />
        </a-form-item>
        <a-form-item
          label="身份证号"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 12 }"
        >
          <a-input
            v-decorator="[
              'idCard',
              {rules: [{required: true,message: '请输入身份证号！'},{validator: this.isCardNo}]}
            ]"
            @blur="validateCardNoBlur"
            placeholder="身份证号"
          />
        </a-form-item>
        <a-form-item
          label="层次"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 12 }"
        >
          <a-select
            v-decorator="[
              'level',
              {rules: [{ required: true, message: '请选择层次！' }]}
            ]"
            placeholder="层次"
            @change="levelChange"
          >
            <a-select-option v-for="item in code.code.type2" :key="item.optionId" :value="item.optionId">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="报考专业"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 12 }"
        >
          <a-select
            v-decorator="[
              'profession',
              {rules: [{ required: true, message: '请选择报考专业！'}]}
            ]"
            placeholder="报考专业"
          >
            <a-select-option v-for="item in realProfession" :key="item.professionId" :value="item.professionId">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          type="number"
          label="联系电话"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 12 }"
        >
          <a-input
            v-decorator="[
              'phoneNumber',
              {rules: [{ required: true, message: '请输入联系电话！' },{validator: this.isPhoneNumber}], validateTrigger: ['change', 'blur']}
            ]"
            placeholder="联系电话"
          />
        </a-form-item>
        <a-form-item
          type="city"
          label="所在地"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 12 }"
        >
          <a-cascader :options="options"
                      v-decorator="[
              'city',
              {rules: [{ required: true, message: '请选择！' }]}
            ]" placeholder="请选择"
          />
        </a-form-item>
        <a-form-item
          label="志愿"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 12 }"
        >
          <a-select
            allowClear
            v-decorator="[
              'volunteer',
              {rules: [{ required: true, message: '请选择志愿！' }]}
            ]"
            placeholder="志愿"
          >
            <a-select-option value="1">第一志愿</a-select-option>
            <a-select-option value="2">第二志愿</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="其它"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 12 }"
        >
          <a-textarea
            v-decorator="[
              'remark',
              {rules: [{required: false,message: '请输入其它信息！'},{max: 100,message: '最大不能超过100！'}]}
            ]"
            placeholder="其它"
          />
        </a-form-item>
        <div :wrapper-col="{ span: 12, offset: 8 }">
          <div class="center-button" style="margin-bottom: 20px;">
            <div class="direction-index">
              <div>
                <strong style="color: red">以上信息必须填写准确（身份证号是个人的唯一标识，请注意填写）</strong>
              </div>
            </div>
          </div>
        </div>
        <a-form-item
          :wrapper-col="{ span: 12, offset: 6 }"
        >
          <div class="center-button">
            <a-button
              type="primary"
              html-type="submit"
              @click="submitdata"
            >
              报名
            </a-button>
          </div>
        </a-form-item>
      </a-form>
      <apply-detail ref="ApplyDetail" @ok="handleOk"></apply-detail>
    </a-card>
  </div>
</template>

<script>
import HeadInfo from '@/components/tools/HeadInfo'
import { getTime, getCode, addObj, isIdCard } from '@api/adult/customChannel.js'
import ApplyDetail from './components/applyDetail'

export default {
  name: 'Custom',
  components: {
    HeadInfo,
    ApplyDetail
  },
  data () {
    return {
      options: [{
        value: '山东省',
        label: '山东省',
        children: [
          { value: '潍坊', label: '潍坊',
            children: [
              {value: '奎文', label: '奎文'},
              {value: '潍城', label: '潍城'},
              {value: '寒亭', label: '寒亭'},
              {value: '坊子', label: '坊子'},
              {value: '青州', label: '青州'},
              {value: '诸城', label: '诸城'},
              {value: '寿光', label: '寿光'},
              {value: '安丘', label: '安丘'},
              {value: '高密', label: '高密'},
              {value: '昌邑', label: '昌邑'},
              {value: '临朐', label: '临朐'},
              {value: '昌乐', label: '昌乐'}
            ]
          },
          { value: '济南', label: '济南' },
          { value: '青岛', label: '青岛' },
          { value: '淄博', label: '淄博' },
          { value: '枣庄', label: '枣庄' },
          { value: '东营', label: '东营' },
          { value: '烟台', label: '烟台' },
          { value: '济宁', label: '济宁' },
          { value: '泰安', label: '泰安' },
          { value: '威海', label: '威海' },
          { value: '日照', label: '日照' },
          { value: '莱芜', label: '莱芜' },
          { value: '临沂', label: '临沂' },
          { value: '德州', label: '德州' },
          { value: '聊城', label: '聊城' },
          { value: '滨州', label: '滨州' },
          { value: '菏泽', label: '菏泽' }
        ]
      }],
      formLayout: 'horizontal',
      form: this.$form.createForm(this),
      startTime: '',
      endTime: '',
      genderList: [
        {
          value: '0',
          label: '男'
        },
        {
          value: '1',
          label: '女'
        }
      ],
      code: {
        profession: {},
        code: {}
      },
      realProfession: [],
      dataList: {}
    }
  },
  created () {
    getTime().then(res => {
      this.startTime = res.data.startTime
      this.endTime = res.data.endTime
    })
    this.getCode()
  },
  methods: {
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    isName (rule, value, callback) {
      var reg = /^[\u4E00-\u9FA5]+$/
      if (reg.test(value) === false) {
        callback(new Error('只能输入汉字且不能有空格'))
      }
      callback()
    },
    isCardNo (rule, value, callback) {
      // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
      var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X)$)/
      if (reg.test(value) === false) {
        callback(new Error('身份证输入不合法 或 X请使用大写'))
      }
      isIdCard(value).then(res => {
        if (res.code !== 0) {
          callback(new Error('该身份证已被注册'))
        } else {
          callback()
        }
      })
    },
    isPhoneNumber (rule, value, callback) {
      var reg = /^[1][3,4,5,7,8][0-9]{9}$/
      if (reg.test(value) === false) {
        callback(new Error('手机号输入不合法'))
      }
      callback()
    },
    submitdata () {
      // eslint-disable-next-line handle-callback-err
      this.form.validateFields((err, values) => {
        if (!err) {
          this.dataList = values
          if (!(values.city===null||values.city===''||values.city===undefined)){
            this.dataList.studentCity = values.city.join('-')
          }
          this.toDetail(values)
        }
      })
    },
    toDetail (value) {
      this.$refs.ApplyDetail.init(value)
    },
    getCode () {
      getCode().then(res => {
        this.code.profession = res.data.profession
        this.code.code = res.data.code
      })
    },
    levelChange (value) {
      this.form.resetFields(`profession`, [])
      this.realProfession = []
      if (value === '0') {
        this.realProfession = this.code.profession.level0
      } else if (value === '1') {
        this.realProfession = this.code.profession.level1
      } else {
        this.realProfession = this.code.profession.level2
      }
    },
    handleOk () {
      addObj(this.dataList).then(res => {
        console.log('resssss', res)
        if (res.code === 0) {
          this.$message.success('报名成功')
          this.form.resetFields()
          this.init()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    validateCardNoBlur (e) {
      console.log(e.target.value)
      isIdCard(e.target.value).then(res => {
        if (res.data === 1) {
          // eslint-disable-next-line no-unused-vars
          const arr = [{
            message: '该身份证已被注册',
            field: 'idCard'
          }]
          this.form.setFields({ idCard: { value: e.target.value, errors: arr } })
        }
      })
    }
  }
}
</script>

<style scoped>

p {
  font-size: 13.5pt;
}

h2 {
  font-weight: bold;
}

.center-button {
  display: flex;
  justify-content: center;
}

.direction-index {
  display: flex;
  flex-direction: column;
}
</style>
